import { masterClient } from '~/core/utils/clients/masterClient'
import type { CountryCode } from '~/core/i18n/types'

const RESOURCE = '/feature_flags/'

export default {
  get({ countryIso }: { countryIso?: CountryCode } = {}) {
    // NOTE: Здесь не нужен camelize
    return masterClient.get<Record<string, boolean>>(
      RESOURCE,
      {
        params: { country_iso: countryIso },
        camelize: false,
      },
    )
  },
}
